export const Options = ({ data, disableSelect }) => {
    return <>
        {!disableSelect && <option value="">Select</option>}
        {data.map(t => <option key={t.value} value={t.value}>{t.text}</option>)}
    </>
        ;
}

export default Options